import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IAnnouncementActiveQueryParams,
  IAnnouncementActiveResponse,
  IAnnouncementPatchBody,
  IAnnouncementPostBody,
  IAnnouncementQueryParams,
  IAnnouncementResponse,
  Resources,
} from '../types'

export class AnnouncementResource extends GenericResource<
  IAnnouncementResponse,
  IAnnouncementQueryParams,
  IAnnouncementPatchBody,
  IAnnouncementPostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public patch = this.buildPatch()
  public post = this.buildPost()

  public listActive = async (params: IAnnouncementActiveQueryParams): Promise<IAnnouncementResponse[]> => {
    const { data } = await this.agent.get<IAnnouncementActiveResponse>('announcements/active', { params })
    return data.announcements
  }

  constructor(agent: IHttpAgent) {
    super(Resources.Announcements, agent)
  }
}
